const api_version_1 = 'api/v1';
const api_version_2 = 'api/v2';

// const base_url = "http://localhost:8000/" + api_version_1;

// const base_url = "http://backend.ibank.sy/v1/public/" + api_version_1;

const base_url = 'https://backend.ibankhoms.sy/api';

// const base_url = "https://backend.ibank.sy/v2/public/api";

export const staticInfo = {
  media_base_url: '',
  map_api_key: '',

  // http services urls
  web_api_urls: {
    // Base URL
    start: base_url + '/start',

    // Auth
    login: base_url + '/auth/login',
    signup: base_url + '/auth/register',
    logout: base_url + '/auth/logout',
    reset_password: base_url + '/resetpassword',
    update_password: base_url + '/updatepassword',

    // Search
    search: base_url + '/search/',

    sub_regions: base_url + '/sub-regions',
    populations: base_url + '/populations',
    agricultural_products: base_url + '/products',

    population_agricultural_products:
      base_url + '/population-agricultural-products',
    // agricultural-statistics-1?product_id=62
    agricultural_statistics_1: base_url + '/agricultural-statistics-1',
    agricultural_statistics_2: base_url + '/agricultural-statistics-2',
    agricultural_statistics_3: base_url + '/agricultural-statistics-3',
    agricultural_statistics_4: base_url + '/agricultural-statistics-4',
    product_amounts_by_sub_region: base_url + '/product-amounts-by-sub-region',

    // map reports
    report_1: base_url + '/report-1',
    report_2: base_url + '/report-2',
    report_3: base_url + '/report-3',
    report_4: base_url + '/report-4',

    // demographic statistics
    demo_statistics_by_population: "https://backend.ibank.sy/bread-and-salt/api/v1/recipients/statistics-by-population",

    // agricaltulral forms
    agri_start: base_url + '/agriStart',
    products_of_productions: base_url + '/getProductsOfProductions',
    amounts_of_populations_of_agricultural_extension:
      base_url + '/getAmountsOfPopulationsOfAgriculturalExtensionOfUser',
    create_crops_vegetables_amount: base_url + '/createCropsVegetablesAmount',
    create_fruitful_trees_amount: base_url + '/createFruitfulTreesAmount',
    create_protected_farms_amount: base_url + '/createProtectedFarmsAmount',
    create_livestock_amounts: base_url + '/createLivestockAmounts',
    delete_product_amount: base_url + '/deleteAmountOfProduct',

    // wheat crop
    wheat_crop: base_url + '/wheat',
    wheat_crop_search: base_url + '/wheatSearch',
    all_wheat_crop_search: base_url + '/wheatSearchAll',
    harvest: base_url + '/harvest',
    // this endpoint for quantities difference report 
    harvest_report_1: base_url + '/harvest-report-1',
    harvest_report_1_search: base_url + '/harvest-report-1-search',
    harvest_report_2: base_url + '/harvest-report-2',
    harvest_report_2_search: base_url + '/harvest-report-2-search',

    // olivepresses
    olive_presses: base_url + '/olivepresses',
    // api/investments?with_crafts=true&investment_id=11
    investments: base_url + '/investments',
    // dams
    dams: base_url + '/dams',
    // industrial_institutions_and_crafts
    crafts: base_url + '/crafts',

    rural_development_projects: base_url + '/ruralDevelopmentProject',
  },

  apis_accept_year_qparam_for_year_interceptor: [
    '/report-1',
    '/report-2',
    '/report-3',
    '/report-4',
    '/product-amounts-by-sub-region',
    '/population-agricultural-products',
    '/agricultural-statistics-1',
    '/agricultural-statistics-2',
    '/agricultural-statistics-3',
    '/agricultural-statistics-4',
    '/ruralDevelopmentProject',
  ],
};

export const staticInfo_old = {
  media_base_url: '',
  map_api_key: '',

  // http services urls
  web_api_urls: {
    // Base URL
    start: base_url + '/start',

    // Auth
    login: base_url + '/auth/login',
    signup: base_url + '/auth/register',
    logout: base_url + '/auth/logout',
    reset_password: base_url + '/resetpassword',
    update_password: base_url + '/updatepassword',

    // Search
    search: base_url + '/search/',

    sub_regions: base_url + '/sub-regions',
    populations: base_url + '/populations',
    agricultural_products: base_url + '/agricultural-products',

    population_agricultural_products:
      base_url + '/population-agricultural-products',
    // agricultural-statistics-1?product_id=62
    agricultural_statistics_1: base_url + '/agricultural-statistics-1',
    agricultural_statistics_2: base_url + '/agricultural-statistics-2',
    agricultural_statistics_3: base_url + '/agricultural-statistics-3',
    agricultural_statistics_4: base_url + '/agricultural-statistics-4',
    product_amounts_by_sub_region: base_url + '/product-amounts-by-sub-region',

    // map reports
    report_1: base_url + '/report-1',
    report_2: base_url + '/report-2',
    report_3: base_url + '/report-3',
    report_4: base_url + '/report-4',

    // agricaltulral forms
    agri_start: base_url + '/agriStart',
    products_of_productions: base_url + '/getProductsOfProductions',
    amounts_of_populations_of_agricultural_extension:
      base_url + '/getAmountsOfPopulationsOfAgriculturalExtensionOfUser',
    create_crops_vegetables_amount: base_url + '/createCropsVegetablesAmount',
    create_fruitful_trees_amount: base_url + '/createFruitfulTreesAmount',
    create_protected_farms_amount: base_url + '/createProtectedFarmsAmount',
    create_livestock_amounts: base_url + '/createLivestockAmounts',
    delete_product_amount: base_url + '/deleteAmountOfProduct',
  },
};
